import { styled } from '@gogovan/entier-web-core/ext/mui/styles';

export const Container = styled('div')`
  background-color: #0088bf;
  color: white;
  border-radius: 60px;

  height: 40px;
  top: auto;
  bottom: 15px;
  left: auto;
  right: 15px;
  position: fixed;

  white-space: nowrap;
  cursor: pointer;
  width: auto;
  overflow: hidden;

  max-width: ${
    ({ opened }) => `${!opened ? 40 : 330}px` // If the phone number is long, max-width needs to be higher
  };
  transition: max-width 0.5s;
`;

export const PhoneContainer = styled('div')`
  opacity: ${({ opened }) => (opened ? 0 : 1)};
  transition: opacity 0.5s;

  position: absolute;
`;

export const DescriptionContainer = styled('div')`
  opacity: ${({ opened }) => (opened ? 1 : 0)};
  transition: opacity 0.5s;
  border-radius: 60px;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TextContainer = styled('div')`
  padding-bottom: 2px;
  padding-left: 20px;
  padding-right: 10px;
`;

export const IconContainer = styled('div')`
  height: 40px;
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
`;
